import { cn } from "@/libs/utils";
import { Button } from "@/v2-components/ui/button";

export default function ProductSelector({
  className,
  categories = [],
  current,
  onChange,
}: {
  current: string;
  className?: string;
  categories: string[];
  onChange?: (category: string) => void;
}) {
  return (
    <div
      className={cn(
        "scrollbar-none flex flex-nowrap items-center justify-start overflow-auto",
        className,
      )}
    >
      {categories.map((category, index) => {
        const selected = current === category;
        return (
          <Button
            key={category}
            onClick={() => onChange?.(category)}
            variant={selected ? "lightgray-fill" : "white"}
            className={cn(
              "min-h-0 shrink-0 px-4 py-2 text-sm font-600 last:mr-0",
              selected ? "bg-coolgray-10 text-black" : "text-coolgray-60",
            )}
          >
            {category}
          </Button>
        );
      })}
    </div>
  );
}
